// test1357
(1357 && 0);
